import OnlyHeader from "components/Layout/OnlyHeader";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Row, Container, Card, CardHeader, Col, Button } from "reactstrap";

function ClientSettingMenu() {
  const { user, userPermissions } = useSelector((state) => state.auth);
  const settingsPermissions = userPermissions?.settings;

  const data = [
    {
      icon: "fas fa-credit-card",
      title: "Payment",
      link: "settings/payment-connection",
    },
    {
      icon: "fas fa-user-cog",
      title: "Tip Settings",
      link: "settings/tip-settings",
    },
    {
      icon: "fas fa-money-check-alt",
      title: "Additional Charges",
      link: "settings/additional-charges",
    },
  ];
  const history = useHistory();
  return (
    <>
      <OnlyHeader />
      <Container fluid className="mt--7">
        <div className="col">
          <Card className="shadow">
            <CardHeader className="d-lg-flex d-sm-block justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  size="sm"
                  color="primary"
                  onClick={() => {
                    history.push("/admin/settings");
                  }}
                >
                  <i className="fas fa-arrow-left "></i>
                </Button>

                <h3 className=" pt-2 ">Client Setting</h3>
              </div>
            </CardHeader>

            <Container className="my-4">
              {user?.type == "kitchen-admin" ? (
                <>
                  {settingsPermissions?.get ? (
                    <Row className="pb-2">
                      {data?.map((el, id) => {
                        return (
                          <Col
                            // md={2}
                            key={id}
                            className="mt-2 d-flex justify-content-center"
                          >
                            <Card
                              className="shadow text-center rounded d-flex justify-content-center align-items-center py-4 px-2 pointer"
                              style={{
                                width: "150px",
                              }}
                              onClick={() => {
                                history.push(`/admin/${el.link}`);
                              }}
                            >
                              <i className={`${el.icon} fa-2x `}></i>
                              <h4 className="mt-2 m-0">{el.title}</h4>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  ) : (
                    <Row className="py-4 justify-content-center align-items-center">
                      You don't have the permission to access the page
                    </Row>
                  )}
                </>
              ) : (
                <Row className="pb-2">
                  {data?.map((el, id) => {
                    return (
                      <Col
                        // md={2}
                        key={id}
                        className="mt-2 d-flex justify-content-center"
                      >
                        <Card
                          className="shadow rounded text-center d-flex justify-content-center align-items-center py-4 px-2 pointer"
                          style={{ width: "150px" }}
                          onClick={() => {
                            history.push(`/admin/${el.link}`);
                          }}
                        >
                          <i className={`${el.icon} fa-2x `}></i>
                          <h4 className="mt-2 m-0">{el.title}</h4>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              )}
            </Container>
          </Card>
        </div>
      </Container>
    </>
  );
}

export default ClientSettingMenu;
